import React, { useLayoutEffect, useRef } from 'react'

// A text box that grows with its words instead of scrolling inside itself.
// singleLine: Enter doesn't add a line (it moves on, like a normal field)
const AutoGrow = React.forwardRef(({ value, onChange, singleLine = false, minRows = 1, className = 'sx-input', onKeyDown, ...rest }, outer) => {
  const ref = useRef(null)
  const setRef = (el) => {
    ref.current = el
    if (typeof outer === 'function') outer(el)
    else if (outer) outer.current = el
  }
  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${el.scrollHeight + (el.offsetHeight - el.clientHeight)}px`
  }, [value])
  return (
    <textarea
      ref={setRef}
      rows={minRows}
      className={`${className} sx-autogrow`}
      value={value || ''}
      onChange={(e) => onChange(singleLine ? e.target.value.replace(/\n/g, ' ') : e.target.value)}
      onKeyDown={(e) => {
        if (singleLine && e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur() }
        if (onKeyDown) onKeyDown(e)
      }}
      {...rest}
    />
  )
})

export default AutoGrow
